import React from "react";

const FormMutedText = ({text}) => {
  if(text) {
    return <small className="form-text text-muted">{text}</small>
  }
  return null
}

export default FormMutedText;